import {ref} from 'vue'
import useGlobalStore from '../store/globalStore'

export function useCommon(index) {
  const globalStore = useGlobalStore()
  const isReadMore = ref(false)
  const showManagerNumberId = ref(null)
  /*const index = ref(0)*/
  const productImpression = (list) => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push(list);
  }

  const openFullGalleryView = (indexVal = 0, isVideo = false, videoUrl = '') => {
    if (window.innerWidth > 768) {
      index.value = indexVal;
    } else if(isVideo) {
      const iframe = `<iframe src="${videoUrl}&rel=0&enablejsapi=1" frameborder="0" allow="autoplay; `+
        `fullscreen" allowfullscreen></iframe>`
      globalStore.setModal(
        {
          name: 'customModal',
          customField: iframe,
        }
      )
    }
  }

  const triggerReadMore = () => {
    isReadMore.value = !isReadMore.value;
  }

  const showTour = (iframe) => {
    globalStore.setModal(
      {
        name: 'modalTour',
        customField: iframe,
      }
    )
  }

  const showManagerNumberButton = (id) => {
    if (id === showManagerNumberId.value) {
      showManagerNumberId.value = null;
    } else {
      showManagerNumberId.value = id;
    }
  }

  const closeLightBox = () => {
    index.value = null
  }

  return {
    productImpression,
    openFullGalleryView,
    isReadMore,
    triggerReadMore,
    showTour,
    showManagerNumberButton,
    showManagerNumberId,
    closeLightBox,
  }
}
